import Axios, { type AxiosInstance, type AxiosPromise } from 'axios';
import ApiService from './apiService';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

interface INavigationService {
	getNavigation(): AxiosPromise<ltFramework.IPage[]>;
}

export const NavigationServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: '/bin/lt/dynamicNav',
	headers: {
		'Content-Type': 'application/json; charset=UTF-8'
	}
});

export default class NavigationService extends ApiService implements INavigationService {
	constructor() {
		super('navigation-service', NavigationServiceAxiosInstance);
	}

	public getNavigation(): AxiosPromise<ltFramework.IPage[]> {
		return this.axiosInstance.get('/');
	}
}

export const navigationService = new NavigationService();
